export const NAME = 'digitalMachines';